import React from 'react';

import useTheme from '@rover/kibble/themes/useTheme';
import useInTrainingPilot from '@rover/react-lib/src/pages/training/hooks/useInTrainingPilot';
import useCountryConfigurationShim from '@rover/shared/js/hooks/useCountryConfigurationShim';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import useLocalizedBrandCountryServices from '@rover/shared/js/hooks/useLocalizedBrandCountryServices';

import { getAvailableServiceDescriptions } from '../utilities/serviceDescriptionUtils';

import ServiceOverview from './ServiceOverview/ServiceOverview';

const ServicesForEveryPet = (): JSX.Element => {
  const { colors } = useTheme();
  const { shouldShowTrainingEntrypoints } = useInTrainingPilot();
  const { navigation } = useCountryConfigurationShim();
  const services = useLocalizedBrandCountryServices();
  const { isAuthenticated } = useCurrentUserShim();

  const countryConfigurationHasPetInsurance = navigation?.hasPetInsurance;
  const availableServices = getAvailableServiceDescriptions(services, colors, {
    shouldShowTrainingEntrypoints,
  });

  const defaultActiveTabId = isAuthenticated ? 'other' : 'overnight';

  return (
    <ServiceOverview
      availableServices={availableServices}
      hasPetInsurance={countryConfigurationHasPetInsurance}
      defaultActiveTabId={defaultActiveTabId}
    />
  );
};

export default ServicesForEveryPet;
